import * as React from "react";
import { AlertColor, Snackbar } from "@mui/material";
import { AccessibleAlert } from "../AccessibleAlert/AccessibleAlert";
import { useDialogState } from "../../hooks/useDialogState/useDialogState";

interface Props {
  message: string;
  severity?: AlertColor;
  horizontal?: "left" | "center" | "right";
  vertical?: "top" | "bottom";
  autoHideDuration?: number | undefined;
}

const SnackbarAlert: React.FC<Props> = ({
  message,
  severity = "info",
  horizontal = "center",
  vertical = "top",
  autoHideDuration = 15000
}) => {
  const [isOpen, , close] = useDialogState(true);

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={autoHideDuration}
      onClose={close}
      anchorOrigin={{ horizontal, vertical }}
      disableWindowBlurListener={true}
      ClickAwayListenerProps={{
        onClickAway: () => {
          // do nothing
        }
      }}
    >
      <AccessibleAlert onClose={close} severity={severity} sx={{ width: "100%" }}>
        {message}
      </AccessibleAlert>
    </Snackbar>
  );
};

export { SnackbarAlert };
